const revertPriceNumner = (price: string) => {
 return parseInt(price.replace(/,/g, ''), 10);
}
export default revertPriceNumner;
